var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import '@shopee/tracking-bootstrap';
import { snakeCase } from 'lodash-es';
var deps = [/* user behavior track */ 'ubt'];
// 将对象的key从驼峰转换为下划线
function transformObjectKey(data) {
    if (Array.isArray(data)) {
        return data.map(function (item) { return transformObjectKey(item); });
    }
    else if (typeof data === 'object' && data !== null) {
        var newObj_1 = {};
        Object.entries(data).forEach(function (_a) {
            var _b = __read(_a, 2), key = _b[0], value = _b[1];
            var _value = transformObjectKey(value);
            newObj_1[snakeCase(key)] = _value;
        });
        return newObj_1;
    }
    else
        return data;
}
/**
 * 初始化Tracking SDK
 *
 */
function init(options) {
    // tracking sdk 一旦初始化不支持修改地区, 当地区发生改变时需要重新初始化
    deps.forEach(function (dep) {
        delete window.trackingSDK[dep];
    });
    var mergedOption = __assign(__assign({ platform: 'pc_web', enableAutoTrack: false }, options), { locale: options.locale.toLowerCase() });
    window.trackingSDK.init(deps, mergedOption, '1.1.4');
    var userId = options.userId;
    userId && setUserId(userId);
}
function warnIfNotInited() {
    if (!window.trackingSDK.ubt) {
        console.warn('Tracking SDK is not initialized');
        return true;
    }
    return false;
}
/** 页面展现 */
function trackView(pageType, data) {
    if (warnIfNotInited()) {
        return;
    }
    window.trackingSDK.ubt('view', pageType, 'pc', data && transformObjectKey(data));
}
/** 点击 */
function trackClick(pageType, pageSection, targetType, data) {
    if (warnIfNotInited()) {
        return;
    }
    window.trackingSDK.ubt('click', pageType, pageSection, targetType, 'pc', data && transformObjectKey(data));
}
/** 元素曝光 */
function trackImpression(pageType, pageSection, targetType, data) {
    if (warnIfNotInited()) {
        return;
    }
    window.trackingSDK.ubt('impression', pageType, pageSection, targetType, 'pc', data && transformObjectKey(data));
}
/** 自定义事件 */
function trackEvent(operation, pageType, pageSection, targetType, data) {
    if (warnIfNotInited()) {
        return;
    }
    window.trackingSDK.ubt('trackEvent', operation, pageType, pageSection, targetType, 'pc', data && transformObjectKey(data));
}
function setUserId(userId) {
    if (warnIfNotInited()) {
        return;
    }
    window.trackingSDK.ubt('setUserId', userId);
}
export var tracking = {
    init: init,
    trackView: trackView,
    trackClick: trackClick,
    trackImpression: trackImpression,
    trackEvent: trackEvent,
    setUserId: setUserId
};
//# sourceMappingURL=index.js.map